import { Chip } from '@mui/material';
import Loading from 'components/Loading';
import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EditIcon from '@mui/icons-material/Edit';
import { HomePageMetadata } from './helpers/types';

const CurrentHomePageChip = ({
    bind,
    homePageMetadata,
    onActionClick,
}: {
    bind: string;
    homePageMetadata: HomePageMetadata;
    onActionClick: () => void;
}) => {
    const { t } = useTranslation();

    if (homePageMetadata.status === 'loading') {
        return <Loading />;
    }
    if (homePageMetadata.status === 'unknown') {
        return (
            <Chip
                color="warning"
                variant="outlined"
                label={t(
                    'support.decisionConfiguration.decisionHomePage.unknownHomePage',
                )}
                onDelete={onActionClick}
                deleteIcon={<EditIcon />}
                icon={<WarningAmberIcon />}
            />
        );
    }
    if (homePageMetadata.isDashboard) {
        return (
            <Chip
                color="primary"
                label={homePageMetadata.homePageTitle}
                variant="outlined"
                clickable
                onClick={() =>
                    window.open(
                        `https://${bind}.manty.eu${homePageMetadata.homePageUrl}`,
                    )
                }
                deleteIcon={<EditIcon />}
                onDelete={onActionClick}
            />
        );
    }
    return (
        <Chip
            color="primary"
            label={t(
                'support.decisionConfiguration.decisionHomePage.defaultHomePage',
            )}
            variant="outlined"
            deleteIcon={<EditIcon />}
            onDelete={onActionClick}
        />
    );
};

export default CurrentHomePageChip;
